import * as d3 from 'd3'
import _ from 'lodash'

const monitor = new class {
  constructor () {
    // Event disaptcher
    this.dispatch = d3.dispatch('activate', 'deactivate')
    // Index of the last activated element
    this.lastActiveElementIndex = -1
    // A list of all monitored elements
    this.elements = []
  }
  has (el) {
    return this.indexOf(el) > -1
  }
  indexOf (el) {
    return _.findIndex(this.elements, {el})
  }
  register (el, value) {
    if (!this.has(el)) {
      this.elements.push({el, value})
      // Start binding scroll
      this.bind()
      // Simulate one scroll
      this.scroll()
    }
  }
  unregister (el) {
    // Remove the element
    this.elements = _.filter(this.elements, {el})
    // Unbind event if there is no elements left
    if (!this.elements.length) {
      this.unbind()
    } else {
      // And scroll again
      this.scroll()
    }
  }
  scroll () {
    const activeElementIndex = this.activeElementIndex()
    // Does it changed?
    if (activeElementIndex > -1 && activeElementIndex !== this.lastActiveElementIndex) {
      // Save it to avoid duplication
      this.lastActiveElementIndex = activeElementIndex
      // And dispatch the event
      const {el, value} = this.elements[activeElementIndex]
      this.dispatch.apply('activate', el, [value])
    }
  }
  activeElementIndex () {
    const positions = this.elements.map(d => d.el.offsetTop)
    const index = d3.bisect(_.compact(positions), this.windowScrollWithOffset)
    return Math.min(this.elements.length - 1, index)
  }
  on (typenames, callback = _.noop) {
    return this.dispatch.on(typenames, callback)
  }
  unbind () {
    return d3.select(window).on('scroll.monitor', null)
  }
  bind () {
    this.unbind()
    // Bind scroll on window (and remove any other one)
    return d3.select(window).on('scroll.monitor', this.scroll.bind(this))
  }
  get windowScrollWithOffset () {
    if (typeof this.offset === 'function') {
      return window.scrollY + this.offset()
    } else {
      return window.scrollY + (this.offset || 0)
    }
  }
}()

export default monitor



// WEBPACK FOOTER //
// ./src/utils/monitor-scroll.js